export const ArrowLeft = ({ isEnabled, onClick }: { isEnabled: boolean; onClick: () => void }) => {
  return (
    <svg onClick={onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0002 7.99994L10.0002 11.9999L14.0002 15.9999"
        stroke={isEnabled ? '#7767E4' : '#BABED6'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
